import React, {useState, useContext, useEffect} from 'react';
import {Link, useParams, useHistory} from 'react-router-dom';

import './izvestaj.styles.css';
import Modal from '../../components/modal/modal';
import Button from '../../utils/buttons/Button';
import {AuthContext} from '../../utils/context/auth-context';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import {useHttpClient} from '../../utils/input/http-hook';

const Izvestaj = () => {

    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    const izvestajId = useParams().izvestajId
    
    
    const auth = useContext(AuthContext);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [loadedIzvestaj, setLoadedIzvestaj] = useState();

    const history = useHistory();

    useEffect(() => {
        const fetchIzvestaj = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BECKEND_URL}/izvestaji/${izvestajId}`
            );
            setLoadedIzvestaj(responseData.izvestaj);
          } catch (err) {}
        };
        fetchIzvestaj();
      }, [sendRequest, izvestajId]);

    const showDeleteWarningHandler = () => {
        setShowConfirmModal(true);
      };
    
      const cancelDeleteHandler = () => {
        setShowConfirmModal(false);
      };

    
      const confirmDeleteHandler = async () => {
        setShowConfirmModal(false);
        try {
          await sendRequest(
            `${process.env.REACT_APP_BECKEND_URL}/izvestaji/${izvestajId}`,
            'DELETE',
            null,
            {
              Authorization: 'Bearer ' + auth.token
            }
          );
          history.push('/izvestaji');
          // onDelete(izvestajId);
        } catch (err) {}
      };
  
       
    return(
        <React.Fragment>  
        <Modal
            show={showConfirmModal}
            onCancel={cancelDeleteHandler}
            header="Are you sure?"
            footerClass="place-item__modal-actions"
            footer={
            <React.Fragment>
                <Button inverse onClick={cancelDeleteHandler}>
                CANCEL
                </Button>
                <Button danger onClick={confirmDeleteHandler}>
                DELETE
                </Button>
            </React.Fragment>
            }             
        >
            <p>
                Do you want to proceed and delete this place? Please note that it
                can't be undone thereafter.
            </p>
        </Modal>
        {isLoading && (
        <div className="center-loader">
          <LoadingSpinner />
        </div>
      )}    
      {!isLoading &&  (
        <div className="post-izvestaj-section">   
          {loadedIzvestaj &&       
            <article id="post-izvestaj">
            <header className="post-header-izvestaj">
              <div className="picture-izvestaj">
                <img src={`${process.env.REACT_APP_ASSET_URL}/${loadedIzvestaj.image}`}  alt={loadedIzvestaj.naslov} />
                <div className="blob-izvestaj">
                  <div className="shape-1-izvestaj">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
              <div className="post-details-izvestaj">
                <h1> <em>{loadedIzvestaj.naslov}</em> </h1>
              </div>
            </header>
            <p className="post-details-izvestaj-text">{loadedIzvestaj.opis}</p>
              {/* <h2>Background</h2>
              <p>Identified as the highest mountain in the world during the 1850s,[1] Everest became a subject of interest during the Golden age of alpinism, although its height made it questionable if it could ever be climbed. In 1885, Clinton Thomas Dent's Above the Snow Line suggested that an ascent might be possible.[2] Practical considerations (and World War I) prevented significant approaches until the 1920s. George Mallory is quoted as having said he wanted to climb Everest "Because it's there", a phrase that has been called "the most famous three words in mountaineering".[3][4] Mallory famously disappeared on Everest during the 1924 British Mount Everest expedition and his fate remained a mystery for 75 years.</p>
            <p>Most early attempts on Everest were made from the north (Tibetan) side, but the Chinese Revolution of 1949, and the subsequent annexation of Tibet led to the closure of that route. Climbers began to look at an approach from the Nepalese side. The 1952 Swiss Mount Everest Expedition, climbing from Nepal, reached an elevation of about 8,595 m (28,199 ft) on the southeast ridge, setting a new climbing altitude record.[5]</p> */}
            {auth.isLoggedIn &&  <Link to={`/izvestaj/${izvestajId}`} className="btn-lined-tick tick-edit">Promeni</Link>}
          {auth.isLoggedIn &&  <button className="btn-lined-tick tick-delete" onClick={showDeleteWarningHandler} >Obrisi</button> } 
            </article>      

          }      
          
          
         </div>

   
            
      )}
        
        </React.Fragment>
        )
        };


export default Izvestaj;